// extracted by mini-css-extract-plugin
export var bodySections = "_ar-8";
export var gray = "_ar-7";
export var green = "_ar-4";
export var iconContainer = "_ar-9";
export var iconWidgetContainer = "_ar-1";
export var phoneIcon = "_ar-2";
export var red = "_ar-5";
export var statusDot = "_ar-3";
export var widgetContainer = "_ar-0";
export var yellow = "_ar-6";